import { isObject } from './obj';
import { isArray } from './array';

/**
 * Handels Ajax-Requests
 * @param  Object  options
 * @return void
 */

export function ajax(options) {
    if (!isObject(options)) {
        throw 'Options must be an object.';
    }

    if (!options.hasOwnProperty('url') || typeof options.url == 'undefined') {
        throw 'Url must be specified.';
    }

    if (!options.hasOwnProperty('method')) {
        options.method = 'POST';
    }

    if (!options.hasOwnProperty('async')) {
        options.async =  true;
    }

    if (!options.hasOwnProperty('contentType')) {
        if (!(options.data instanceof FormData)) {
            options.contentType =  'application/json';
        }
    }

    if (!options.hasOwnProperty('data')) {
        options.data = {};
    }

    if (!options.hasOwnProperty('success')) {
        options.success =  () => {};
    }

    if (!options.hasOwnProperty('error')) {
        options.error =  () => {};
    }

    const xhr = new XMLHttpRequest();

    xhr.open(options.method, options.url, options.async);

    if (options.contentType) {
        xhr.setRequestHeader('Content-Type', options.contentType);
    }

    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('X-CSRF-TOKEN', document.head.querySelector("[name=csrf-token]").content);

    const preparedData = options.data instanceof FormData
        ? addTokenToFormData(options.data)
        : prepareDataForXHR(options.data);

    xhr.send(preparedData);
    xhr.responseType = options.responseType || '';

    xhr.onreadystatechange = () => {
        const DONE = 4;              // readyState 4 means the request is done.
        const OK = 200;              // status 200 is a successful return.
        const UNAUTHORIZED = 401;    // status 401 user is unauthorized.

        if (xhr.status == UNAUTHORIZED) {
            window.location = '/login/switch';
            return false;
        }

        if (xhr.readyState != DONE) {
            return;
        }

        if (xhr.status != OK) {
            options.error(xhr.responseText);
            return;
        }

        options.success(xhr.responseText);
    }
}

/**
 * Daten für Ajax-Request vorbereiten
 *
 * Token hinzufügen und Error werfen, wenn kein Token übergeben
 * wurde und keines im Meta-Tag des DOM vorhanden ist
 * @param  Object data
 * @return String
 */
function prepareDataForXHR(data){
    let token = false;

    if(document.head.querySelector("[name=csrf-token]")) {
        token = document.head.querySelector("[name=csrf-token]").content;
    }

    if(isArray(data) && typeof data['_token'] == 'undefined'){
        if(!token)
            throw "No token passed!";

        let output = {};
        output.data = data;
        output['_token'] = token;
        return JSON.stringify(output);
    }

    if(isObject(data) && !('_token' in data)){
        if(!token)
            throw "No token passed!";

        data._token = token;
    }

    return JSON.stringify(data);
}

function addTokenToFormData(formData) {
    const token = document.head.querySelector('[name=csrf-token]').content;

    formData.append('_token', token);

    return formData;
}
